/**
 * プリセット詳細ページ コンテナ
 */
import type React from "react";
import { useCallback } from "react";
import { useParams } from "react-router-dom";
import type { MatchingResultItem } from "../../../hooks/use-free-matching-api";
import { usePreset, usePresetResults } from "../../../hooks/use-preset-api";
import { restClient } from "../../../lib/rest-client";
import { PresetDetailPage } from "./PresetDetailPage";

/**
 * プリセット詳細ページのコンテナコンポーネント
 * @return {JSX.Element} PresetDetailPage コンテナ
 */
const PresetDetailPageContainer: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const { preset, loading: presetLoading } = usePreset(id);
  const {
    results,
    total,
    loading: resultsLoading,
    refetch: refetchResults,
  } = usePresetResults(id);

  const handlePropose = useCallback(
    async (result: MatchingResultItem) => {
      await restClient.patch<MatchingResultItem>(
        `/matching/results/${result.id}/status`,
        { status: "proposed" },
      );
      await refetchResults();
    },
    [refetchResults],
  );

  return (
    <PresetDetailPage
      preset={preset}
      loading={presetLoading}
      results={results}
      resultsTotal={total}
      resultsLoading={resultsLoading}
      onPropose={handlePropose}
    />
  );
};

export default PresetDetailPageContainer;
